import { APP_NAME } from '@/constants'

export default function setPageTitle(name?: string): void {
  window.document.title = name ? name : APP_NAME
}
